module.exports = __webpack_public_path__ + "img/muyequAppImage.f245a774.png";